// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pONSg","glbSection":"styles_glbSection__vLSfK"};